import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
} from 'reactstrap';
import PlusIcon from 'mdi-react/PlusIcon';


const TodoSidebar = ({ changeShowEditModal, filterByPriority }) => {
  const addNewTask = () => {
    changeShowEditModal();
  };

  const handlePriorityChange = (e) => {
    filterByPriority(e.target.value);
  };

  return (
    <div className="todo__input-new">
      <div className="todo__sidebar">        
        <Button className="todo__btn-add-new" onClick={addNewTask}><PlusIcon /> Nueva Tarea</Button>
        <div className="todo__priority-filter">
          <p className="title">Prioridad</p>
          <ul className="todo__priority-filter-list">
            <li>
              <input
                className="todo__filter-radio"
                type="radio"
                id="priority-all"
                name="priority-filter"
                value=""
                onClick={handlePriorityChange}
                defaultChecked
              />
              <label htmlFor="priority-all">Todos</label>
            </li>
            <li>
              <input
                className="todo__filter-radio"
                type="radio"
                id="priority-low"
                name="priority-filter"
                value="low"
                onClick={handlePriorityChange}
              />
              <label htmlFor="priority-low">Prioridad Baja</label>
            </li>
            <li>
              <input
                className="todo__filter-radio"
                type="radio"
                id="priority-medium"
                name="priority-filter"
                value="medium"
                onClick={handlePriorityChange}
              />
              <label htmlFor="priority-medium">Prioridad Media</label>
            </li>
            <li>
              <input
                className="todo__filter-radio"
                type="radio"
                id="priority-high"
                name="priority-filter"
                value="high"
                onClick={handlePriorityChange}
              />
              <label htmlFor="priority-high">Prioridad Alta</label>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

TodoSidebar.propTypes = {
  changeShowEditModal: PropTypes.func.isRequired,
  filterByPriority: PropTypes.func.isRequired,
};

export default TodoSidebar;
